export { ProfessionalPartnershipsDetails } from './ProfessionalPartnershipsDetails'
